module.exports = __webpack_public_path__ + "static/media/acpi-logo.2c2c8855.svg";